import { Fab, IconButton, makeStyles, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography, withStyles } from '@material-ui/core'
import { NavigateBefore, NavigateNext } from '@material-ui/icons';
import React, { useEffect, useState } from 'react'
import { Search } from '../../component/molecules';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import Cookies from 'js-cookie';
import { addDataPencatatanRetur, setDataBarang, setFillFormBarang, setSearch} from '../../config/redux/action';
import { useHistory } from 'react-router-dom';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import AddIcon from '@material-ui/icons/Add';
import FormReturBarang from '../../component/organism/FormReturBarang';


const DataBarangToRetur = () => {
    const useStyles = makeStyles((theme)=>({
        root:{
            width:'100%',
            height:'100%'
        },
        content:{
            display:'flex',
            flexDirection:'column',
            alignItems:'center',
            justifyContent:'center'
        },
        search:{
            marginRight:'21%',
            width:'15%',
            [theme.breakpoints.down('xs')]:{
                width:'30%',
                marginRight:'5%',
            },
        },
        table:{
            marginTop:'5px',
            width:'90%',
            maxWidth:'800px',
        },
        tableContainer:{
            height:'580px',
            [theme.breakpoints.up('xs')]:{
                height:'400px'
            },
        },
        page:{
            display:'flex',
            width:'100%',
            margin:'0px',
        },
        textPage:{
            padding:'10px',
        },
        tableBottom:{
            display:'flex',
            flexDirection:'row',
            alignContent:'space-between'
        },
        buttonHistory:{
            position: 'fixed',
            bottom: theme.spacing(2),
            left: theme.spacing(2),
        }
    }));
    const SytledTableCell = withStyles((theme)=>({
        head: {
            backgroundColor: 'grey',
            color: theme.palette.common.black,
          },
          body: {
            fontSize: 14,
            // border:'1px solid black'
          },
    }))(TableCell);
    const StyledTableRow = withStyles((theme) => ({
        root: {
          '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
          },
        },
      }))(TableRow);
    const classes = useStyles();
    const {dataBarang,pageBarang,search} = useSelector(state => state.barangReducers);
    const {data} = useSelector(state => state.loginReducers);
    const [counter,setCounter] = useState(1);
    const [openRetur,setOpenRetur] = useState(false);
    const dispatch = useDispatch();
    const [token,setToken] = useState(data.token);
    const history = useHistory();
    if(token ===''){
        setToken(Cookies.get('u_tkn'));
    }
    useEffect(()=>{
        dispatch(setDataBarang(search,counter,token));
    },[search,counter,token,dispatch])
    
    const focus = () =>{
        setCounter(1);
        dispatch(setDataBarang(search,counter,token));
    }
    const handlePrev = () =>{
        setCounter(counter <= 1? 1 : counter - 1);
    }
    const handleNext = () =>{
        setCounter(counter === pageBarang.totalPage ? pageBarang.totalPage : counter + 1);
    }
    const HandleClickCloseFormReturDialog = () =>{
        setCounter(1);
        dispatch(setDataBarang(search,counter,token));
        dispatch(setFillFormBarang());
        dispatch(setSearch(''));
        setOpenRetur(false);
    }
    const HandleClickOpenFormReturDialog = (idbarang) =>{
        dispatch(addDataPencatatanRetur(idbarang,token));
        dispatch(setSearch(''));
        setOpenRetur(true);
    }
    return (
        <div className={classes.root}>
            <div className={classes.content}>
            <Search className={classes.search} 
            label="Cari Barang" 
            name="cari-barang" 
            id="cari-barang" 
            onFocus={focus} 
            value={search}
            onChange={(e)=>dispatch(setSearch(e.target.value))}/>
            <div className={classes.table}>
                    <Paper>
                        <TableContainer className={classes.tableContainer}>
                            <Table stickyHeader aria-label="table barang" size="small">
                                <TableHead>
                                    <TableRow>
                                        <SytledTableCell width='10%' align="center">ID Barang</SytledTableCell>
                                        <SytledTableCell width='35%' align="center">Nama Barang</SytledTableCell>
                                        <SytledTableCell width='3%' align="center"></SytledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {dataBarang.map((dataBarangs=>(
                                        <StyledTableRow key={dataBarangs.idbarang}>
                                            <SytledTableCell align="center">{dataBarangs.idbarang}</SytledTableCell>
                                            <SytledTableCell align="center">{dataBarangs.namabarang}</SytledTableCell>
                                            <SytledTableCell align="center">
                                                    <Tooltip title="Tambah ke daftar retur">
                                                        <IconButton size='small' onClick={()=>HandleClickOpenFormReturDialog(dataBarangs.idbarang)}>
                                                            <AddIcon/>
                                                        </IconButton>
                                                    </Tooltip>
                                                </SytledTableCell>
                                        </StyledTableRow>
                                    )))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <div className={classes.tableBottom}>
                                <div className={classes.page}>
                                <Tooltip title="Prev">
                                    <IconButton size='small' onClick={handlePrev}>
                                        <NavigateBefore/>
                                    </IconButton>
                                </Tooltip>
                                <Typography className={classes.textPage}>{pageBarang.currentPage} / {pageBarang.totalPage >= 1 ? pageBarang.totalPage : pageBarang.currentPage}</Typography>
                                <Tooltip title="Next">
                                    <IconButton size='small' onClick={handleNext}>
                                        <NavigateNext/>
                                    </IconButton>
                                </Tooltip> 
                                </div>
                         </div>
                    </Paper>
                </div>    
                <FormReturBarang open={openRetur} aria-labelledby="add-form-retur" HandleClickCloseDialog={HandleClickCloseFormReturDialog}/>
                <Fab className={classes.buttonHistory} size="small" color="primary" aria-label="add" onClick={()=>history.goBack()}>
                    <ArrowBackIcon/>
                </Fab>
            </div>
        </div>
    )
}

export default DataBarangToRetur
